import 'apps/hiring/styles/components/opening-invite.scss';
import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import PropTypes from 'prop-types';
import CopyButton from 'library/components/copy-button';
import MultipleInput from 'library/components/form-elements/multiple-input';
import SavingButton from 'library/components/saving-button';
import HiringQuery from 'apps/hiring/util/query';
import withData from 'util/hoc/with-data';
import { ShimmyZone, ShimmyValue } from 'library/components/shimmy';
import { jsonToInputParams } from 'library/util/graph';
import Carrot from 'library/icons/caret.svg';
import withUser from 'util/hoc/with-user';

class InviteEmployees extends React.Component {
  state = {
    emails: '',
    saving: false,
    bulk: false,
    edit: false,
    subject: null,
    body: null
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (this.state.emails === '' || this.state.disabled) {
      return;
    }

    this.setState({
      saving: true
    });

    if (this.state.emails === '') {
      return;
    }

    const { openingId } = this.props;
    const { emails, body, subject } = this.state;

    const params = {
      opening_id : openingId,
      emails: emails.split(','),
    };

    if (subject !== null ) params.email_subject = subject;
    params.email_body = body
      || resolve(this.props.graph_data, 'employee_invitation_template/body', '');
    params.email_body=params.email_body.replace(/[\r\n]/g, '<br />');

    const response = await HiringQuery(`
      mutation {
        invite_employees (${jsonToInputParams(params)}) {
          success,
          errors,
          invitation {
            invalid,
            scheduled
          }
        }
      }
    `);

    if (resolve(response, 'data/invite_employees/success', false)) {
      this.props.closeModal();
    } else {
      this.setState({
        saving: false
      });
    }
  }

  handleChange = ({ target }) => {
    const { name, value } = target;

    this.setState({
      [name]: value
    });
  }

  toggleEdit = () => {
    this.props.toggleEdit();
    this.setState({ edit: !this.state.edit });
  }

  toggleBulk = () => {
    this.setState(({...nextState}) => {
      nextState.bulk = !nextState.bulk;

      if (!nextState.bulk) {
        nextState.emails = resolve(nextState.emails.split(','), '0', '');
      }

      return nextState;
    });
  }

  render() {
    const {
      saving,
      emails,
      bulk,
      edit,
      subject,
      body
    } = this.state;

    const { graph_data } = this.props;

    return (
      <Fragment>
        <ShimmyValue namespace="hiring-modal-header-invite">
          <p key="invite-title">INVITE EMPLOYEES</p>
        </ShimmyValue>
        <div className="hiring-modal-invite-link">
          <span><strong>DIRECT LINK</strong> {`${__SURVEYURL__}/signup/${this.props.currentOrganization}/employee`}</span>
          <CopyButton component="span" className="a" value={`${__SURVEYURL__}/signup/${this.props.currentOrganization}/employee`}>
            COPY LINK
          </CopyButton>
        </div>
        <form onSubmit={this.handleSubmit} disabled={saving} className={bulk || edit ?'form':'form-inline'}>
          { edit
            ? (
              <div className='modify-email-content'>
                <label>
                  Subject
                  <input name='subject' onChange={this.handleChange}  value={subject === null ?resolve(graph_data, 'employee_invitation_template/subject', ''): subject} />
                </label>
                <label>
                  Body
                  <textarea style={{ width: '100%' }} rows={7} name='body' onChange={this.handleChange} value={body === null ? resolve(graph_data, 'employee_invitation_template/body', '') : body} />
                </label>
              </div>
            ) :
            null
          }
          {
            bulk
              ? (
                <Fragment>
                  <h3>
                    Add Email Addresses
                    <small>As you type more rows will appear</small>
                  </h3>
                  <div style={{minHeight: '300px'}}>
                    <MultipleInput name="emails" value={emails} onChange={this.handleChange} type="email" placeholder="Email Address" />
                  </div>
                </Fragment>
              )
              : <input name="emails" onChange={this.handleChange} value={resolve(emails.split(','), '0', '')} type="email" placeholder="Email Address" />
          }
          <SavingButton saving={saving} type="submit">Send</SavingButton>
        </form>
        {
          bulk
            ? (
              <span className="a" onClick={this.toggleBulk}>SINGLE INVITE</span>
            )
            : <span className="a" onClick={this.toggleBulk}>BULK INVITE</span>
        }
        <span className="a" style={{ float: 'right', marginTop: 6 }} onClick={this.toggleEdit}>
          EMAIL CONTENT
          <Carrot style={{ marginLeft: '4px' }} className={['flip-then-rotate-180', edit? null: 'active'].filter(c=>c).join(' ')}/>
        </span>
      </Fragment>
    );
  }
}

InviteEmployees.propTypes = {
  closeModal: PropTypes.func,
  openingId: PropTypes.number,
  currentOrganization: PropTypes.string,
  toggleEdit: PropTypes.func,
  graph_data: PropTypes.array
};

InviteEmployees.query = (
  ` {
  employee_invitation_template {
        body,
        subject
      }
    }
`);

export default withUser(withData(InviteEmployees));
